import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const c = localStorage.getItem("acdt_cookie_consent");
      if (!c) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) { /* noop */ }
  }, []);

  const set = (value) => {
    try {
      localStorage.setItem("acdt_cookie_consent", value);
    } catch (e) { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[70] p-4 md:p-6">
      <div className="max-w-4xl mx-auto rounded-2xl bg-white border border-slate-200 shadow-[0_30px_80px_-20px_rgba(16,42,107,0.35)] p-5 md:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex h-12 w-12 rounded-xl bg-[#f59e0b]/15 text-[#b45309] items-center justify-center shrink-0">
            <Cookie className="h-6 w-6" />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-base md:text-lg font-extrabold text-[#0a1f55]">
                Utilizziamo i cookie
              </h3>
              <button onClick={() => set("essential")} aria-label="Chiudi" className="h-8 w-8 rounded-md hover:bg-slate-100 flex items-center justify-center text-slate-500">
                <X className="h-4 w-4" />
              </button>
            </div>
            <p className="mt-2 text-[13.5px] text-slate-600 leading-relaxed">
              Utilizziamo cookie tecnici necessari al funzionamento del sito e, previo tuo consenso,
              cookie di analisi anonima per migliorare l'esperienza. Per maggiori informazioni consulta la{" "}
              <Link to="/cookie-policy" className="text-[#102a6b] font-semibold underline">
                Cookie Policy
              </Link>{" "}
              e la{" "}
              <Link to="/privacy-policy" className="text-[#102a6b] font-semibold underline">
                Privacy Policy
              </Link>.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <Button onClick={() => set("all")} className="bg-[#102a6b] hover:bg-[#0a1f55] text-white">
                Accetta tutti
              </Button>
              <Button onClick={() => set("essential")} variant="outline" className="border-slate-300 text-[#102a6b] hover:bg-[#102a6b]/5 hover:text-[#102a6b]">
                Solo essenziali
              </Button>
              <Link to="/cookie-policy">
                <Button variant="ghost" className="text-[#102a6b] hover:bg-[#102a6b]/5 hover:text-[#102a6b]">
                  Personalizza
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
